import { TimeSlot } from './time-slot.model';

export class TimeSlots {
  pickup: TimeSlot; 
  delivery: TimeSlot;
}